import { SignupEmbedder } from 'signup-embedder';
export const doesTargetWindowExist = () => {
  const isPopup = SignupEmbedder.isPopup();
  if (isPopup) {
    return Boolean(window.opener);
  } else if (window.parent !== window.self) {
    return Boolean(window.parent);
  }
  return false;
};